// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1ZoBf","rootSuccess":"CompleteLink_rootSuccess__LK-ec","rootFailure":"CompleteLink_rootFailure__2EiVq","isDisabled":"CompleteLink_isDisabled__1g57n"};